import { Routes, Route } from "react-router-dom";
import { OsciLpcoMainRouter } from "@/tz/go/egaz/osci/lpco/router/OsciLpcoMainRouter";
import { OsciColtMainRouter } from "@/tz/go/egaz/osci/colt/router/OsciColtMainRouter";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn";

/*
 * System main router
 * !== 시스템 메인 라우터 ==!
 */
export const Main = () => {
    return (
        <Routes>
            {/*
             * path : 웹 경로 설정, "*" 표시는 하위 모든 주소 매핑
             * element : 해당 path에 매핑될 하위 Router 컴포넌트
             */}
            <Route path={`osci/colt/*`} element={<OsciColtMainRouter />} />
            <Route path={`osci/lpco/*`} element={<OsciLpcoMainRouter />} />
        </Routes>
    );
};
